/**
 * Resolve src de foto/vídeo do modal de Fotos (Fechamento).
 * Primário GO: url opaca da API; legado: data URL base64 TB00110.
 */
export function resolveCheckoutFotoSrc(foto) {
  if (!foto || typeof foto !== 'object') return '';
  if (foto.url != null && String(foto.url).trim()) {
    return String(foto.url).trim();
  }
  if (foto.base64 != null && String(foto.base64).trim()) {
    const mime = foto.mimeType || 'image/jpeg';
    return `data:${mime};base64,${foto.base64}`;
  }
  return '';
}

export function isCheckoutMediaVideo(foto) {
  if (!foto || typeof foto !== 'object') return false;
  if (foto.isVideo === true) return true;
  return String(foto.mimeType || '')
    .toLowerCase()
    .startsWith('video/');
}
